import exifr from 'exifr';

const DATE_KEYS = [
    'DateTimeOriginal', 'CreateDate', 'ModifyDate', 'DateTimeDigitized', 'DateTime',
] as const;

/** Camera photos pass through the image editor and get this suffix (see useCanvasEditor). */
const CAMERA_EDITED_NAME = /-edited\./i;

const toIso = (raw: unknown): string | undefined => {
    if (raw == null || raw === '') return undefined;
    const d = raw instanceof Date ? raw : new Date(raw as string | number);
    return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
};

export const getImageCaptureDate = async (file: globalThis.File): Promise<string | undefined> => {
    try {
        const exif = await exifr.parse(file, {
            tiff: true, exif: true, ifd1: true, xmp: true,
            pick: [...DATE_KEYS], reviveValues: true,
        });
        if (exif) {
            for (const key of DATE_KEYS) {
                const iso = toIso((exif as Record<string, unknown>)[key]);
                if (iso) return iso;
            }
        }
    } catch { /* no EXIF in file */ }
    if (!window['cordova'] && file.lastModified) {
        return new Date(file.lastModified).toISOString();
    }
    return undefined;
};

export const buildImageMetadataEntry = async (
    file: globalThis.File
): Promise<{ dc?: string; sz?: number }> => {
    let dc = await getImageCaptureDate(file);
    const name = file.name || '';
    const fromCamera = window['cordova'] && CAMERA_EDITED_NAME.test(name);
    const isIosCamera = window['device']?.platform === 'iOS' && /^IMG_|^CDV_/i.test(name);

    if (!dc && (fromCamera || isIosCamera)) {
        dc = new Date().toISOString();
    }

    return {
        ...(dc ? { dc } : {}),
        ...(file.size ? { sz: file.size } : {}),
    };
};
